import styled from 'styled-components';

export const TestimonialContainer = styled.section(
	({ theme: { down, breakpoints } }) => `

      ${down(breakpoints.tb)} {
          padding-left: 20px;
					max-height:none;
      }
      padding: 50px 0;
      max-width: 1200px;
      width: 100%;
			margin: 0 auto;
			max-height:452px;
  
    `
);

export const TestimonialTextWrap = styled.p(
	({ theme: { down, breakpoints } }) => `

      ${down(breakpoints.md)} {
          flex-direction: column-reverse;
      }
      font-size: 16px;
      padding: 20px 0 30px 0;
  
    `
);

export const TestimonialInnerWrap = styled.article(
	({ theme: { down, breakpoints } }) => `
  	padding-right: 100px;
		${down(breakpoints.md)} {
			padding-right: 50px;
			width: 300px !important;
		}

		img{
				border-radius: 10px;
		}

	`
);

export const SliderOuterWrap = styled.div`
.slick-track, > div > div > div {
    display: flex;
  }
`;
